/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'AgreementIndex',
    path: '/agreement/index',
    component: () =>
      import(
        /* webpackChunkName: "AgreementIndex" */ '@/views/agreement/index'
      ),
    meta: { title: '法律条款与隐私政策' },
  },
  {
    name: 'AgreementLocationInfoIndex',
    path: '/agreement/location-info',
    component: () =>
      import(
        /* webpackChunkName: "AgreementIndex" */ '@/views/agreement/location-info/index'
      ),
    meta: { title: '用户轨迹' },
  },
  {
    name: 'AgreementPersonInfoCollectIndex',
    path: '/agreement/person-info',
    component: () =>
      import(
        /* webpackChunkName: "AgreementIndex" */ '@/views/agreement/person-info-collect/index'
      ),
    meta: { title: '个人信息收集清单' },
  },
  {
    name: 'AgreementPrivacy',
    path: '/agreement/privacy',
    component: () =>
      import(
        /* webpackChunkName: "AgreementPrivacy" */ '@/views/agreement/privacy'
      ),
    meta: { title: '用户隐私政策' },
  },
  {
    name: 'AgreementSoftware',
    path: '/agreement/software',
    component: () =>
      import(
        /* webpackChunkName: "AgreementSoftware" */ '@/views/agreement/software'
      ),
    meta: { title: '网约车用户服务协议' },
  },
  {
    name: 'AgreementSafeRules',
    path: '/agreement/safe-rules',
    component: () =>
      import(
        /* webpackChunkName: "AgreementSoftware" */ '@/views/agreement/safe-rules'
      ),
    meta: { title: '平台安全规则' },
  },
  {
    name: 'RecordRules',
    path: '/agreement/record-rules',
    component: () =>
      import(
        /* webpackChunkName: "RecordRules" */ '@/views/agreement/record-rules'
      ),
    meta: { title: '行程录音授权协议' },
  },
  {
    name: 'InsuranceRules',
    path: '/agreement/insurance-rules',
    component: () =>
      import(
        /* webpackChunkName: "InsuranceRules" */ '@/views/agreement/insurance-rules'
      ),
    meta: { title: '小拉出行保险保障' },
  },
  {
    name: 'AgreementIosSdk',
    path: '/agreement/ios-sdk',
    component: () =>
      import(
        /* webpackChunkName: "AgreementIosSdk" */ '@/views/agreement/ios-sdk.vue'
      ),
    meta: { title: 'iOS-SDK目录' },
  },
  {
    name: 'AgreementAndroidSdk',
    path: '/agreement/android-sdk',
    component: () =>
      import(
        /* webpackChunkName: "AgreementAndroidSdk" */ '@/views/agreement/android-sdk.vue'
      ),
    meta: { title: 'Android-SDK目录' },
  },
  {
    name: 'AgreementHarmonySdk',
    path: '/agreement/harmony-sdk',
    component: () =>
      import(
        /* webpackChunkName: "AgreementHarmonySdk" */ '@/views/agreement/harmony-sdk.vue'
      ),
    meta: { title: ' Harmony-SDK目录' },
  },
  // {
  //   name: 'AgreementPersonInfo', //废弃
  //   path: '/agreement/person-info',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "agreementPersonInfo" */ '@/views/agreement/person-info.vue'
  //     ),
  //   meta: { title: '个人信息收集清单' },
  // },

  {
    name: 'AgreementPersonChecklist',
    path: '/agreement/person-check-list',
    component: () =>
      import(
        /* webpackChunkName: "agreementPersonChecklist‌" */ '@/views/agreement/person-check-list.vue'
      ),
    meta: { title: '个人信息收集清单' },
  },
  {
    name: 'AgreementPermissionList',
    path: '/agreement/permission-list',
    component: () =>
      import(
        /* webpackChunkName: "AgreementPermissionList" */ '@/views/agreement/permission-list.vue'
      ),
    meta: { title: '个人信息权限调用清单' },
  },
  {
    name: 'AgreementAbstract',
    path: '/agreement/privacy-abstract',
    component: () =>
      import(
        /* webpackChunkName: "AgreementAbstract" */ '@/views/agreement/privacy-abstract.vue'
      ),
    meta: { title: '用户隐私政策' },
  },
  {
    name: 'AgreementThirdList',
    path: '/agreement/third-list',
    component: () =>
      import(
        /* webpackChunkName: "AgreementThirdList" */ '@/views/agreement/third-list.vue'
      ),
    meta: { title: '第三方信息共享清单' },
  },
  {
    name: 'businessLicense',
    path: '/business-license/index',
    component: () =>
      import(
        /* webpackChunkName: "businessLicense" */ '@/views/business-license/index.vue'
      ),
    meta: { title: '证照信息' },
  },

  {
    name: 'AgreementPrivacyList',
    path: '/agreement/privacy-list',
    component: () =>
      import(
        /* webpackChunkName: "AgreementPrivacyList" */
        '@/views/agreement/privacy-list'
      ),
    meta: { title: '历史版本' },
  },

  {
    name: 'AgreementPrivacyCommon',
    path: '/agreement/common',
    component: () =>
      import(
        /* webpackChunkName: "AgreementPrivacyCommon" */
        '@/views/agreement/common.vue'
      ),
    meta: { title: '' },
  },

  {
    name: 'AgreementCustom',
    path: '/agreement/custom',
    component: () =>
      import(
        /* webpackChunkName: "AgreementCustom" */
        '@/views/agreement/custom'
      ),
    meta: { title: '小拉出行' },
  },

  {
    name: 'AgreementCustom',
    path: '/agreement/user-privacy-rules',
    component: () =>
      import(
        /* webpackChunkName: "UserPrivacyRules" */
        '@/views/agreement/root-rule/user-privacy-rules'
      ),
    meta: { title: '用户隐私政策及平台规则' },
  },
  {
    name: 'AgreementCustom',
    path: '/agreement/ride-hailing-rules',
    component: () =>
      import(
        /* webpackChunkName: "RideHailingRules" */
        '@/views/agreement/root-rule/ride-hailing-rules'
      ),
    meta: { title: '网约车用户服务相关协议及政策' },
  },
  {
    name: 'AgreementCustom',
    path: '/agreement/ride-sharing-rules',
    component: () =>
      import(
        /* webpackChunkName: "RideSharingRules" */
        '@/views/agreement/root-rule/ride-sharing-rules'
      ),
    meta: { title: '小拉出行顺风车相关协议及政策' },
  },
];
